
import React from 'react';
import './OtherArticles.scss';
import imageUrlBuilder from "@sanity/image-url";
import { useNavigate, useMatch, useLocation, useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Slider from 'react-slick';
import journeyArrow from '../../assets/img/journeyArrow.svg';
import { whitelists } from '../../i18n';

function OtherArticles(props) {

  const match = useMatch('/:lang/*');
  let lang = match && match.params ? (whitelists.includes(match.params.lang) ? match.params.lang : null) : null;
  //console.log(lang)
  const postLink = lang ? `/${lang}/post/` : `/post/`;
  const backLink = lang ? `/${lang}/blog` : `/blog`;
  const navigate = useNavigate();
  const handleClickPostFull = (id) => {
    navigate(`${postLink}${id}`);
  };

  const [postData, setPostData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const PROJECT_ID = "2tnperol";
      const DATASET = "production";
      const QUERY = encodeURIComponent(
        `*[_type == "post"]{_id,title,shortText,_updatedAt,mainImage, author->, body[],  "image": image{...,"asset": asset->,}}`
      );

      const PROJECT_URL = `https://${PROJECT_ID}.api.sanity.io/v2021-10-21/data/query/${DATASET}?query=${QUERY}`;

      try {
        const response = await fetch(PROJECT_URL);
        const { result } = await response.json();
        setPostData(result);
       // console.log(result);
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, []);

  const builder = imageUrlBuilder({
    projectId: "2tnperol",
    dataset: "production",
  });

  function formatDate(dateStr) {
    const inputDate = new Date(dateStr);
    const monthNames = [
      "January", "February", "March", "April", "May", "June", "July",
      "August", "September", "October", "November", "December"
    ];
    const month = monthNames[inputDate.getMonth()];
    const day = inputDate.getDate();
    const year = inputDate.getFullYear();
    return `${month} ${day}, ${year}`;
  }

  const blogShortItem = postData && postData.map((item) => {
    if(item._id !== props.currentPageId){
      const title = item.title ? (lang == null ? item.title.ru : item.title[lang]) : "";
      //const shortText = item.shortText ? (lang == null ? item.shortText.ru : item.shortText[lang]) : "";
      console.log("currentPageId in articls  ------> "+ props.currentPageId)
      return (
        <div className='other-blog-main-item-wrapper' key={item._id}>
          <div className="other-blog-content">
            <div>
              {item.mainImage && item.mainImage.asset && (
                <div className='other-main-image-position'>
                  <img
                    src={builder.image(item.mainImage.asset._ref).url()}
                    alt={item.author}
                    //style={{ maxWidth: "100%", maxHeight: "100%" }}
                  />
                </div>
              )}
              <div className="other-blog-text-content">
                <div className="other-blog-date" >{formatDate(item._updatedAt.split("T")[0])}</div>
                <div className="other-blog-text-title" >{title}</div>
                
              </div>
              <div className="other-blog-button">
                <button onClick={() => { handleClickPostFull(item._id); }}>{props.t("blog_card_button")}</button>
                <img src={journeyArrow} alt="offer link" />
              </div>
            </div>
          </div>
        </div>
      );
    }
   
  });

  let itemLength = blogShortItem.length;

  const settings = {
    dots: true,
    speed: 500,
    slidesToShow: itemLength === 1 ? 1 : (itemLength === 2 ? 1 : 3),
    slidesToScroll: itemLength === 1 ? 1 : (itemLength === 2 ? 1 : 3),
    rows: (itemLength % 6 === 0) ? 2 : 1,
    responsive: [
      {
        breakpoint: 1285,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
          rows: 1
        }
      },
      {
        breakpoint: 1255,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 880,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <div className="other-blog-wrapper">
     <div className="other-back">
      <div className="other-back-capture">
        {props.t("other_title")}
      </div>
      <div className="other-back-link">
        <Link to={backLink}>{props.t("other_link")}</Link>
      </div>
     </div>
      <div className="other-blog-slider-block">
        {blogShortItem && (
          <Slider {...settings} >
            {blogShortItem}
          </Slider>
        )}
      </div>
    </div>
  );
}

export default OtherArticles;